import { BALANCE_SLIDE_STEP } from '../../data-types/enums';
import { CardType, DEPOSIT_CONFIRMATION_TYPE } from '../../data-types/wallet/walletEnums';
import { RESET_STATE } from '../types/stateTypes';
import {
  SET_ACKNOWLEDGE_DEPOSIT_OPEN,
  SET_DEPOSIT_AMOUNT,
  SET_DEPOSIT_CARD_TYPE,
  SET_DEPOSIT_CONFIRMATION_TYPE,
  SET_DEPOSIT_NOTIFICATION_CONTENT,
  SET_DEPOSIT_TRACKING_INFO,
  SET_MOBILE_PAYMENT_INIT_DIALOG,
  SET_USER_BALANCE,
  SET_USER_BONUS_WALLET,
  SET_USER_PAYMENT_METHODS_DATA,
  SET_USER_PAYMENT_METHODS_DATA_LOADING,
  SET_USER_TOTAL_BALANCE,
  SET_WALLET_BALANCE_TYPE_DISPLAY,
  WalletActionType,
  WalletState,
} from '../types/walletTypes';

export const initialWalletState: WalletState = {
  balance: 0,
  totalBalance: 0,
  bonusWallet: undefined,
  depositInfo: {
    amount: 0,
    cardType: CardType.DEPOSIT,
    depositConfirmationType: DEPOSIT_CONFIRMATION_TYPE.THANK_YOU_CARD,
    appNotification: {
      title: '',
      content: '',
    },
  },
  depositTrackingInfo: {
    transactionId: undefined,
    depositAmount: undefined,
  },
  mobilePaymentInitDialog: {
    open: false,
    amount: 0,
    currency: '',
    phoneNumber: '',
  },
  userPaymentMethodsData: {
    canAddNew: false,
    loadingPaymentMethods: undefined,
    cards: [],
    paymentMethodsWithNoAccounts: [],
  },
  acknowledgeDepositOpen: false,
  walletBalanceTypeDisplay: BALANCE_SLIDE_STEP.BONUS,
};

export const walletReducer = (state = initialWalletState, action: WalletActionType): WalletState => {
  switch (action.type) {
    case RESET_STATE:
      return {
        ...initialWalletState,
      };
    case SET_USER_BALANCE:
      return { ...state, balance: action.meta };
    case SET_DEPOSIT_CONFIRMATION_TYPE: {
      return { ...state, depositInfo: { ...state.depositInfo, depositConfirmationType: action.meta } };
    }
    case SET_DEPOSIT_AMOUNT: {
      return { ...state, depositInfo: { ...state.depositInfo, amount: action.meta } };
    }
    case SET_DEPOSIT_CARD_TYPE: {
      return { ...state, depositInfo: { ...state.depositInfo, cardType: action.meta } };
    }
    case SET_DEPOSIT_NOTIFICATION_CONTENT: {
      return { ...state, depositInfo: { ...state.depositInfo, appNotification: action.meta } };
    }
    case SET_DEPOSIT_TRACKING_INFO: {
      return { ...state, depositTrackingInfo: action.meta };
    }
    case SET_MOBILE_PAYMENT_INIT_DIALOG: {
      return { ...state, mobilePaymentInitDialog: action.meta };
    }
    case SET_USER_PAYMENT_METHODS_DATA: {
      return {
        ...state,
        userPaymentMethodsData: action.meta,
      };
    }
    case SET_USER_PAYMENT_METHODS_DATA_LOADING: {
      return {
        ...state,
        userPaymentMethodsData: {
          ...state.userPaymentMethodsData,
          loadingPaymentMethods: action.meta,
        },
      };
    }
    case SET_ACKNOWLEDGE_DEPOSIT_OPEN: {
      return { ...state, acknowledgeDepositOpen: action.meta };
    }
    case SET_USER_TOTAL_BALANCE: {
      return { ...state, totalBalance: action.meta };
    }
    case SET_USER_BONUS_WALLET: {
      return { ...state, bonusWallet: action.meta };
    }
    case SET_WALLET_BALANCE_TYPE_DISPLAY: {
      return { ...state, walletBalanceTypeDisplay: action.meta };
    }
    default:
      return state;
  }
};
